(function () {
  /* v12: menos espacio en blanco (sin equalHeight en bundle/cross) */
  if (window.__nebPDPInitVersion >= 12) { return; }
  if (window.__nebPDPOnClick) document.removeEventListener('click', window.__nebPDPOnClick);
  if (window.__nebPDPOnChange) document.removeEventListener('change', window.__nebPDPOnChange);
  if (window.__nebPDPOnSubmit) document.removeEventListener('submit', window.__nebPDPOnSubmit);
  if (window.__nebPDPOnKeydown) document.removeEventListener('keydown', window.__nebPDPOnKeydown);
  window.__nebPDPInitVersion = 12;
  window.__nebPDPv12 = true;
  window.__nebPDPv11 = true;
  window.__nebPDPv10 = true;
  window.__nebPDPv9 = true;
  window.__nebPDPv8 = true;
  window.__nebPDPv7 = true;
  window.__nebPDPv6 = true;
  window.__nebPDPv5 = true;
  window.__nebPDPv4 = true;
  window.__nebPDPv3 = true;
  window.__nebPDPInit = true;

  var doc = document;
  var win = window;
  var Nebulix = {
    body: doc.body,
    cartDrawerEl: null
  };
  window.NebulixPDP = Nebulix;

  function fmtCOP(value) {
    var v = Number(value || 0) / 100;
    return '$' + Math.round(v).toLocaleString('es-CO');
  }

  function shopRoot() {
    var root = (win.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  function shopUrl(path) {
    path = String(path || '').replace(/^\//, '');
    return shopRoot() + path;
  }

  function cartFetch(url, opts) {
    opts = opts || {};
    var headers = Object.assign({
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }, opts.headers || {});
    /* Siempre absolutas al root de la tienda.
       Si usamos "cart/add.js" relativo en /products/foo → /products/cart/add.js (roto). */
    if (url && url.indexOf('http') !== 0) {
      url = shopUrl(String(url).replace(/^\//, ''));
    }
    if (typeof FormData !== 'undefined' && opts.body instanceof FormData) {
      delete headers['Content-Type'];
      delete headers['content-type'];
    }
    return fetch(url, Object.assign({
      credentials: 'same-origin'
    }, opts, { headers: headers }));
  }

  function toVariantId(raw) {
    if (raw == null || raw === '') return '';
    var s = String(raw).trim();
    if (!/^\d+$/.test(s)) return '';
    return s;
  }

  function getProductMeta(root) {
    var meta = (win.__NEB_PRODUCT__ && typeof win.__NEB_PRODUCT__ === 'object') ? win.__NEB_PRODUCT__ : {};
    root = root || doc.querySelector('[data-neb-buybox]');
    return {
      handle: (root && root.getAttribute('data-product-handle')) || meta.handle || '',
      variantId: toVariantId((root && root.getAttribute('data-variant-id')) || meta.variantId || ''),
      productId: toVariantId((root && root.getAttribute('data-product-id')) || meta.productId || '')
    };
  }

  function getEmbeddedProduct(root) {
    var jsonEl = (root && root.querySelector('[data-neb-product-json]')) ||
      doc.querySelector('[data-neb-buybox] [data-neb-product-json], [data-neb-product-json]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (err) {
      return null;
    }
  }

  function pickVariantId(variants, hinted, productId, skipId) {
    if (!variants || !variants.length) return '';
    var skip = toVariantId(skipId);
    var map = {};
    for (var i = 0; i < variants.length; i++) {
      var vid = toVariantId(variants[i] && variants[i].id);
      if (vid) map[vid] = variants[i];
    }
    var hint = toVariantId(hinted);
    if (hint && map[hint] && hint !== productId && hint !== skip) {
      if (map[hint].available !== false) return hint;
    }
    for (var j = 0; j < variants.length; j++) {
      var row = variants[j];
      var id = toVariantId(row && row.id);
      if (!id || id === productId || id === skip) continue;
      if (row && row.available !== false) return id;
    }
    for (var k = 0; k < variants.length; k++) {
      var id2 = toVariantId(variants[k] && variants[k].id);
      if (id2 && id2 !== productId && id2 !== skip) return id2;
    }
    return '';
  }

  function handleFromLocation() {
    try {
      var path = String((win.location && win.location.pathname) || '');
      var m = path.match(/\/products\/([^\/\?\#]+)/i);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (err) {
      return '';
    }
  }

  function fetchStorefrontProduct(handle) {
    handle = handle || handleFromLocation();
    if (!handle) return Promise.resolve(null);

    var urls = [
      shopUrl('products/' + encodeURIComponent(handle) + '.js'),
      (win.location && win.location.origin ? win.location.origin : '') + shopUrl('products/' + encodeURIComponent(handle) + '.js')
    ];

    function tryUrl(i) {
      if (i >= urls.length) return Promise.resolve(null);
      return fetch(urls[i], {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (r) {
        if (!r.ok) return tryUrl(i + 1);
        return r.json().then(function (j) { return j; }).catch(function () { return tryUrl(i + 1); });
      }).catch(function () { return tryUrl(i + 1); });
    }
    return tryUrl(0);
  }

  function syncVariantUi(alt) {
    alt = toVariantId(alt);
    if (!alt) return;
    doc.querySelectorAll('[data-selected-variant]').forEach(function (el) { el.value = alt; });
    doc.querySelectorAll('[data-neb-buybox]').forEach(function (el) { el.setAttribute('data-variant-id', alt); });
    doc.querySelectorAll('[data-add-to-cart]').forEach(function (el) { el.setAttribute('data-variant', alt); });
    if (win.__NEB_PRODUCT__) win.__NEB_PRODUCT__.variantId = alt;
  }

  function postCartAddOnce(variantId, quantity) {
    variantId = toVariantId(variantId);
    quantity = Math.max(1, parseInt(quantity, 10) || 1);
    if (!variantId) {
      return Promise.reject(new Error('ID de variante vacío.'));
    }

    /* UN solo request — varios reintentos provocan HTTP 429 en Shopify */
    return cartFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: quantity }]
      })
    }).then(function (r) {
      if (r.ok) return r.json();
      return r.text().then(function (text) {
        var msg = 'Error al agregar (HTTP ' + r.status + ')';
        try {
          var j = JSON.parse(text);
          msg = (j && (j.description || j.message)) || msg;
        } catch (e) { /* html */ }
        if (r.status === 429) {
          msg = 'Demasiados intentos. Espera 10 segundos y vuelve a probar.';
        }
        var err = new Error(msg);
        err.status = r.status;
        err.variantId = variantId;
        throw err;
      });
    });
  }

  function isVariantMissingError(err) {
    if (!err) return false;
    if (err.status === 429 || err.status === 430) return false;
    var msg = String(err.message || '').toLowerCase();
    if (msg.indexOf('429') !== -1 || msg.indexOf('demasiados') !== -1) return false;
    return msg.indexOf('variante') !== -1 || msg.indexOf('variant') !== -1 || err.status === 404 || err.status === 422;
  }

  /* Resuelve 1–2 IDs máximo: preferred (UI) + primera available de product.js si es distinta */
  function resolveBestVariantIds(handle, preferredId) {
    var preferred = toVariantId(preferredId);
    var meta = getProductMeta();
    handle = handle || meta.handle || handleFromLocation();

    return fetchStorefrontProduct(handle).then(function (p) {
      var live = '';
      var productId = toVariantId(p && p.id) || meta.productId;
      if (p && p.variants && p.variants.length) {
        for (var i = 0; i < p.variants.length; i++) {
          var row = p.variants[i];
          var vid = toVariantId(row && row.id);
          if (!vid || vid === productId) continue;
          if (row.available !== false) { live = vid; break; }
        }
        if (!live) live = toVariantId(p.variants[0] && p.variants[0].id);
      }

      var ids = [];
      var seen = {};
      function add(id) {
        id = toVariantId(id);
        if (!id || id === productId || seen[id]) return;
        seen[id] = true;
        ids.push(id);
      }

      /* Primero el de la vitrina (product.js); luego el de la UI si es distinto */
      add(live);
      add(preferred);
      add(meta.variantId);
      if (win.__NEB_PRODUCT__) add(win.__NEB_PRODUCT__.variantId);

      if (!ids.length && preferred) ids = [preferred];
      /* Máximo 2 intentos para no saturar el carrito */
      return ids.slice(0, 2);
    });
  }

  function postCartAdd(id, qty, handle) {
    var quantity = Math.max(1, parseInt(qty, 10) || 1);
    var first = toVariantId(id);
    handle = handle || handleFromLocation();

    return resolveBestVariantIds(handle, first).then(function (ids) {
      if (!ids.length) {
        return Promise.reject(new Error('No hay variante vendible para este producto.'));
      }

      var idx = 0;
      function tryNext(lastErr) {
        if (idx >= ids.length) {
          var msg = (lastErr && lastErr.message) || 'No se encontró la variante';
          return Promise.reject(new Error(msg + (ids.length ? ' · id=' + ids.join(',') : '')));
        }
        var current = ids[idx++];
        return postCartAddOnce(current, quantity).then(function (res) {
          syncVariantUi(current);
          return res;
        }).catch(function (err) {
          if (err && err.status === 429) throw err;
          if (!isVariantMissingError(err)) throw err;
          return tryNext(err);
        });
      }
      return tryNext(null);
    });
  }

  /* Al cargar: reemplazar ID Liquid/?variant= viejo por el de product.js (canal real) */
  function hydrateBuyboxVariantFromStorefront() {
    var root = doc.querySelector('[data-neb-buybox]');
    if (!root) return;
    var handle = getProductMeta(root).handle || handleFromLocation();
    if (!handle) return;
    fetchStorefrontProduct(handle).then(function (p) {
      if (!p || !p.variants || !p.variants.length) return;
      var liveIds = [];
      p.variants.forEach(function (v) {
        var id = toVariantId(v && v.id);
        if (id) liveIds.push(id);
      });
      if (liveIds.length) root.setAttribute('data-variant-ids', liveIds.join(','));
      var pick = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i] && p.variants[i].available !== false) {
          pick = p.variants[i];
          break;
        }
      }
      if (!pick) pick = p.variants[0];
      var liveId = toVariantId(pick && pick.id);
      if (!liveId) return;
      syncVariantUi(liveId);
      if (win.__NEB_PRODUCT__) {
        win.__NEB_PRODUCT__.variantId = liveId;
        win.__NEB_PRODUCT__.variantIds = liveIds;
        win.__NEB_PRODUCT__.variants = p.variants.map(function (v) {
          return { id: String(v.id), available: v.available !== false, title: v.title };
        });
      }
    });
  }

  Nebulix.addItems = function (items, opts) {
    opts = opts || {};
    var list = items || [];
    if (!list.length) return Promise.reject(new Error('Nada para agregar.'));
    var handle = opts.handle || '';

    var chain = Promise.resolve();
    list.forEach(function (it) {
      chain = chain.then(function () {
        var h = it.handle || handle || getProductMeta().handle || handleFromLocation();
        return postCartAdd(it.id, it.quantity, h);
      });
    });

    return chain
      .then(function () { return cartFetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { Nebulix.renderCart(cart); })
      .then(function () { Nebulix.openDrawer(); });
  };

  function resolveQty(addBtn) {
    var form = addBtn && addBtn.closest('form');
    var root = addBtn && (addBtn.closest('[data-neb-buybox]') || addBtn.closest('.neb-section-buybox'));
    var qtyEl = (form && form.querySelector('[data-qty]')) ||
      (root && root.querySelector('[data-qty]')) ||
      doc.querySelector('[data-neb-buybox] [data-qty], .neb-section-buybox [data-qty]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) : Nebulix.getBuyboxQty();
    if (!qty || qty < 1) qty = 1;
    return qty;
  }

  Nebulix.setCount = function (n) {
    var total = n || 0;
    doc.querySelectorAll('[data-neb-cart-count]').forEach(function (el) {
      el.textContent = total;
      el.classList.toggle('neb-hidden', total === 0);
    });
  };

  Nebulix.closeDrawer = function () {
    if (Nebulix.cartDrawerEl) Nebulix.cartDrawerEl.classList.remove('is-open');
    Nebulix.body.classList.remove('neb-prevent-scroll');
  };

  Nebulix.openDrawer = function () {
    if (!Nebulix.cartDrawerEl) return;
    Nebulix.cartDrawerEl.classList.add('is-open');
    Nebulix.body.classList.add('neb-prevent-scroll');
    Nebulix.loadCart();
  };

  function buildShippingBar(wrapper, cart) {
    var threshold = parseInt(wrapper.getAttribute('data-shipping-threshold') || '0', 10);
    if (!(threshold > 0)) return { html: '', pct: 0, unlocked: false };
    var total = (cart && cart.total_price) || 0;
    var remaining = Math.max(0, threshold - total);
    var pct = Math.min(100, Math.round((total / threshold) * 100));
    var unlocked = remaining === 0 && total > 0;
    var title = unlocked
      ? (wrapper.getAttribute('data-shipping-unlocked') || '¡Tienes envío gratis!')
      : (wrapper.getAttribute('data-shipping-title') || '¡Agrega más productos para envío gratis!');
    var prefix = wrapper.getAttribute('data-shipping-prefix') || 'Te faltan';
    var suffix = wrapper.getAttribute('data-shipping-suffix') || 'para envío gratis';
    var msg = remaining > 0
      ? '<p class="neb-shipbar__msg">' + prefix + ' <strong>' + fmtCOP(remaining) + '</strong> ' + suffix + '</p>'
      : '<p class="neb-shipbar__msg"><strong>Meta alcanzada</strong> · Envío gratis aplicado</p>';
    var icon = unlocked
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12l5 5L20 7" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="1.5"/><path d="M12 7v14M4 15h16" stroke-linecap="round"/><path d="M12 11c-2.2-3.2-4.8-3.8-6-2.2-1 1.2-.2 2.8 2.2 3.2M12 11c2.2-3.2 4.8-3.8 6-2.2 1 1.2.2 2.8-2.2 3.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var html = '<div class="neb-shipbar' + (unlocked ? ' is-unlocked' : '') + '" style="--neb-ship-pct:0;">' +
      '<p class="neb-shipbar__title">' + title + '</p>' +
      '<div class="neb-shipbar__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="Progreso hacia envío gratis">' +
        '<div class="neb-shipbar__fill"></div>' +
        '<span class="neb-shipbar__icon">' + icon + '</span>' +
      '</div>' +
      msg +
    '</div>';
    return { html: html, pct: pct, unlocked: unlocked };
  }

  function paintShippingBar(wrapper, cart) {
    var slot = wrapper && wrapper.querySelector('[data-shipping-slot]');
    if (!slot) return;
    var prevBar = slot.querySelector('.neb-shipbar');
    var fromPct = 0;
    if (prevBar) {
      var raw = prevBar.style.getPropertyValue('--neb-ship-pct') || getComputedStyle(prevBar).getPropertyValue('--neb-ship-pct');
      fromPct = parseFloat(raw) || 0;
    }
    var built = buildShippingBar(wrapper, cart || { total_price: 0 });
    if (!built.html) return;
    var wasUnlocked = !!(prevBar && prevBar.classList.contains('is-unlocked'));
    slot.innerHTML = built.html;
    slot.classList.remove('neb-hidden');
    var bar = slot.querySelector('.neb-shipbar');
    if (!bar) return;
    bar.style.setProperty('--neb-ship-pct', String(fromPct));
    win.requestAnimationFrame(function () {
      win.requestAnimationFrame(function () {
        bar.style.setProperty('--neb-ship-pct', String(built.pct));
        if (built.unlocked && !wasUnlocked) {
          bar.classList.remove('is-unlocked');
          void bar.offsetWidth;
          bar.classList.add('is-unlocked');
        }
      });
    });
  }

  function paintAllShippingBars(cart) {
    var roots = doc.querySelectorAll('[data-shipping-root]');
    [].forEach.call(roots, function (wrapper) {
      paintShippingBar(wrapper, cart);
    });
  }

  Nebulix.renderCart = function (cart) {
    var wrapper = Nebulix.cartDrawerEl;
    if (!wrapper) return;
    var body = wrapper.querySelector('[data-cart-body]');
    var foot = wrapper.querySelector('[data-cart-foot]');
    Nebulix.setCount(cart.item_count);
    paintAllShippingBars(cart);
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="neb-cart-empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.3 4.2a1 1 0 00.9 1.4h13.9M9 21a1 1 0 100-2 1 1 0 000 2zm8 0a1 1 0 100-2 1 1 0 000 2z" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '<p>Tu carrito está actualmente vacío</p>' +
        '<a class="neb-btn neb-btn--ghost" href="/collections/all">Continuar comprando</a>' +
        '</div>';
      if (foot) foot.classList.add('neb-hidden');
      return;
    }

    if (foot) foot.classList.remove('neb-hidden');
    var items = cart.items.map(function (it) {
      var img = it.featured_image && it.featured_image.url
        ? '<img src="' + it.featured_image.url + '&width=200" alt="' + (it.product_title || '') + '" loading="lazy">'
        : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      return '<div class="neb-cart-item" data-line="' + it.key + '">' +
        '<a class="neb-cart-item__img" href="' + it.url + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="neb-cart-item__info">' +
          '<p class="neb-cart-item__name">' + it.product_title + '</p>' +
          '<p class="neb-cart-item__variant">' + variant + '</p>' +
          '<div class="neb-cart-item__row">' +
            '<div class="neb-qty">' +
              '<button type="button" data-cart-qty="-1" aria-label="Reducir cantidad">−</button>' +
              '<input value="' + it.quantity + '" data-qty-input readonly aria-label="Cantidad">' +
              '<button type="button" data-cart-qty="1" aria-label="Aumentar cantidad">+</button>' +
            '</div>' +
            '<span class="neb-cart-item__price">' + fmtCOP(it.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="neb-cart-item__remove" data-cart-remove>Eliminar</button>' +
        '</div>' +
      '</div>';
    }).join('');

    body.innerHTML = items;
    foot.innerHTML =
      '<div class="neb-cart-sidebar__subtotal"><span>Subtotal</span><b>' + fmtCOP(cart.total_price) + '</b></div>' +
      '<button type="button" class="neb-btn neb-btn--block" data-cart-checkout>Pagar ahora</button>';
  };

  Nebulix.loadCart = function () {
    cartFetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      Nebulix.renderCart(cart);
    }).catch(function () {
      var empty = { items: [], item_count: 0, total_price: 0, currency: 'COP' };
      if (Nebulix.cartDrawerEl) Nebulix.renderCart(empty);
    });
  };

  Nebulix.changeLine = function (key, qty) {
    var params = new URLSearchParams();
    params.set('id', String(key));
    params.set('quantity', String(qty));
    cartFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: params.toString()
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'No se pudo actualizar el carrito.'); });
        return r.json();
      })
      .then(function (cart) { Nebulix.renderCart(cart); })
      .catch(function (err) {
        Nebulix.toast((err && err.message) || 'No se pudo actualizar el carrito.', 'error');
      });
  };

  Nebulix.announce = function (text, type) {
    var el = doc.querySelector('[data-neb-announce]');
    if (el) {
      el.textContent = text;
      el.className = 'neb-newsletter__msg ' + (type === 'error' ? 'is-error' : 'is-ok');
    }
  };

  Nebulix.toast = function (text, type) {
    var el = doc.querySelector('[data-neb-toast]');
    if (!el) {
      el = doc.createElement('div');
      el.setAttribute('data-neb-toast', '');
      el.className = 'neb-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      doc.body.appendChild(el);
    }
    el.textContent = text;
    el.className = 'neb-toast is-visible' + (type === 'error' ? ' is-error' : ' is-ok');
    clearTimeout(Nebulix._toastTimer);
    Nebulix._toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 3200);
  };

  Nebulix.getBuyboxQty = function () {
    var qtyEl = doc.querySelector('.neb-buybox [data-qty], [data-product-form] [data-qty], [data-qty-box] [data-qty]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
    return (!qty || qty < 1) ? 1 : qty;
  };

  Nebulix.setMobileMenuOpen = function (open) {
    var menu = doc.querySelector('[data-mobile-menu]');
    if (!menu) return;
    menu.classList.toggle('is-open', !!open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    Nebulix.body.classList.toggle('neb-prevent-scroll', !!open);
  };

  function pad(s) { return s || ''; }

  function initGallery(root) {
    var slides = [].slice.call(root.querySelectorAll('.neb-gallery__slide-img'));
    if (!slides.length) return;
    var mainImg = root.querySelector('.neb-gallery__main-img');
    var index = 0;

    root.__index = index;

    function render() {
      var n = index;
      if (mainImg && slides[n]) {
        mainImg.src = slides[n].getAttribute('data-full') || slides[n].src;
        mainImg.alt = slides[n].getAttribute('data-alt') || '';
      }
      root.classList.remove('is-zoomed');
      root.querySelectorAll('.neb-gallery__dot').forEach(function (d, i) { d.classList.toggle('is-active', i === n); });
      root.querySelectorAll('.neb-gallery__thumb').forEach(function (t, i) { t.classList.toggle('is-active', i === n); });
      var mainEl = root.querySelector('.neb-gallery__main');
      if (mainEl) mainEl.classList.remove('is-zoomed');
      var prev = root.querySelector('.neb-arrow--prev');
      var next = root.querySelector('.neb-arrow--next');
      if (prev) prev.disabled = n === 0;
      if (next) next.disabled = n === slides.length - 1;
    }

    root.querySelectorAll('.neb-gallery__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        index = parseInt(t.getAttribute('data-index'), 10);
        render();
      });
    });
    root.querySelectorAll('.neb-gallery__dot').forEach(function (d) {
      d.addEventListener('click', function () {
        index = parseInt(d.getAttribute('data-index'), 10);
        render();
      });
    });
    var prevBtn = root.querySelector('.neb-arrow--prev');
    var nextBtn = root.querySelector('.neb-arrow--next');
    if (prevBtn) prevBtn.addEventListener('click', function () { if (index > 0) { index -= 1; render(); } });
    if (nextBtn) nextBtn.addEventListener('click', function () { if (index < slides.length - 1) { index += 1; render(); } });

    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var diff = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(diff) < 40) return;
      if (diff < 0 && index < slides.length - 1) { index += 1; render(); }
      if (diff > 0 && index > 0) { index -= 1; render(); }
    }, { passive: true });

    var main = root.querySelector('.neb-gallery__main');
    if (main) {
      /* Zoom solo con doble clic en desktop; sin hover permanente */
      main.addEventListener('dblclick', function (e) {
        if (window.matchMedia('(hover: none)').matches) return;
        e.preventDefault();
        main.classList.toggle('is-zoomed');
      });
    }

    render();
  }

  document.querySelectorAll('[data-neb-gallery]').forEach(initGallery);

  function collapse(item, instant) {
    item.classList.remove('is-open');
    var p = item.querySelector('.neb-acc-panel');
    if (p) p.style.maxHeight = '0px';
  }

  function expand(item) {
    item.classList.add('is-open');
    var p = item.querySelector('.neb-acc-panel');
    if (p) p.style.maxHeight = p.scrollHeight + 'px';
  }

  function toggleAcc(item) {
    var open = item.classList.contains('is-open');
    if (open) collapse(item); else expand(item);
  }

  window.__nebPDPOnClick = function (e) {
    var t = e.target;

    var cartOpen = t.closest('[data-cart-open]');
    if (cartOpen) { e.preventDefault(); Nebulix.openDrawer(); return; }

    if (t.closest('[data-cart-close]')) { Nebulix.closeDrawer(); return; }

    var menuToggle = t.closest('[data-menu-open]');
    if (menuToggle) {
      Nebulix.setMobileMenuOpen(true);
      return;
    }
    var menuClose = t.closest('[data-menu-close]');
    if (menuClose) {
      Nebulix.setMobileMenuOpen(false);
      return;
    }

    if (t.closest('.neb-mobile-menu__overlay')) {
      Nebulix.setMobileMenuOpen(false);
      return;
    }

    if (t.closest('.neb-mobile-item > .neb-accordion-trigger')) {
      t.closest('.neb-mobile-item').classList.toggle('is-open');
      return;
    }

    var cartItem = t.closest('.neb-cart-item');
    if (cartItem) {
      var line = cartItem.getAttribute('data-line');
      var qb = t.closest('[data-cart-qty]');
      if (qb) {
        var cur = cartItem.querySelector('[data-qty-input]');
        var cv = cur ? parseInt(cur.value, 10) : 1;
        Nebulix.changeLine(line, Math.max(1, cv + parseInt(qb.getAttribute('data-cart-qty'), 10)));
        return;
      }
      if (t.closest('[data-cart-remove]')) { Nebulix.changeLine(line, 0); return; }
    }

    var checkoutBtn = t.closest('[data-cart-checkout]');
    if (checkoutBtn) { window.location.href = '/checkout'; return; }

    var panelTrigger = t.closest('[data-panel-trigger]');
    if (panelTrigger) {
      var panelEl = panelTrigger.closest('.neb-tabs__panel');
      var pbody = panelEl.querySelector('.neb-panel-body');
      var pOpen = panelEl.classList.contains('is-open');
      panelEl.classList.toggle('is-open', !pOpen);
      if (pbody) {
        pbody.style.maxHeight = pOpen ? '0px' : Math.max(pbody.scrollHeight, panelEl.scrollHeight) + 'px';
      }
      return;
    }

    var accTrigger = t.closest('.neb-acc-item > .neb-accordion-trigger');
    if (accTrigger) {
      var accItem = t.closest('.neb-acc-item');
      var root = accItem.closest('[data-acc]');
      if (root && root.getAttribute('data-acc') === 'exclusive') {
        root.querySelectorAll('.neb-acc-item.is-open').forEach(function (el) {
          if (el !== accItem) collapse(el);
        });
      }
      toggleAcc(accItem);
      return;
    }

    var tab = t.closest('.neb-tab-btn');
    if (tab) {
      doc.querySelectorAll('.neb-tab-btn.is-active').forEach(function (el) { el.classList.remove('is-active'); });
      doc.querySelectorAll('.neb-tabs__panel.is-active').forEach(function (el) { el.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var panel = doc.getElementById(tab.getAttribute('data-target'));
      if (panel) panel.classList.add('is-active');
      return;
    }

    var swatch = t.closest('.neb-swatch');
    if (swatch) {
      var group = swatch.closest('[data-swatches]');
      group.querySelectorAll('.neb-swatch').forEach(function (s) {
        s.classList.remove('is-active');
        s.setAttribute('aria-pressed', 'false');
      });
      swatch.classList.add('is-active');
      swatch.setAttribute('aria-pressed', 'true');
      var colorEl = doc.querySelector(group.getAttribute('data-color-target'));
      if (colorEl) colorEl.textContent = 'Color: ' + swatch.getAttribute('data-color');
      var hidden = doc.querySelector(group.getAttribute('data-variant-target'));
      if (hidden && swatch.getAttribute('data-variant')) hidden.value = swatch.getAttribute('data-variant');
      var vid = swatch.getAttribute('data-variant');
      if (vid) {
        doc.querySelectorAll('[data-add-to-cart]').forEach(function (b) { b.setAttribute('data-variant', vid); });
        var buybox = swatch.closest('[data-neb-buybox], .neb-section-buybox');
        if (buybox) buybox.setAttribute('data-variant-id', vid);
      }
      var priceEl = doc.querySelector(group.getAttribute('data-price-target'));
      if (priceEl && swatch.getAttribute('data-price')) priceEl.textContent = fmtCOP(swatch.getAttribute('data-price'));
      var compareEl = doc.querySelector(group.getAttribute('data-compare-target'));
      var compareVal = swatch.getAttribute('data-compare');
      if (compareEl) {
        if (compareVal && parseInt(compareVal, 10) > parseInt(swatch.getAttribute('data-price'), 10)) {
          compareEl.textContent = fmtCOP(compareVal);
        } else {
          compareEl.textContent = '';
        }
      }
      return;
    }

    var nav = t.closest('[data-cross-prev], [data-cross-next]');
    if (nav) {
      /* Carrusel cross-sell lo maneja initSlider; legacy scrollBy solo si hay data-target */
      var targetId = nav.getAttribute('data-target');
      if (targetId) {
        var trackLegacy = doc.getElementById(targetId);
        var dir = nav.hasAttribute('data-cross-prev') ? -1 : 1;
        if (trackLegacy) trackLegacy.scrollBy({ left: dir * trackLegacy.clientWidth * 0.7, behavior: 'smooth' });
      }
      return;
    }

    var cardAdd = t.closest('[data-card-add]');
    if (cardAdd) {
      var card = cardAdd.closest('[data-card-product], .neb-product-card');
      var variantSelect = card && card.querySelector('[data-card-variant-select]');
      var cardId = toVariantId(
        (variantSelect && variantSelect.value) ||
        cardAdd.getAttribute('data-variant')
      );
      var cardHandle =
        cardAdd.getAttribute('data-product-handle') ||
        (card && card.getAttribute('data-product-handle')) ||
        '';
      var q = parseInt(cardAdd.getAttribute('data-quantity') || '1', 10);
      if (!cardId) {
        Nebulix.toast('Selecciona una variante.', 'error');
        return;
      }
      cardAdd.disabled = true;
      cardAdd.classList.add('is-loading');
      Nebulix.addItems([{ id: cardId, quantity: q, handle: cardHandle }], { handle: cardHandle }).then(function () {
        cardAdd.disabled = false;
        cardAdd.classList.remove('is-loading');
      }).catch(function (err) {
        cardAdd.disabled = false;
        cardAdd.classList.remove('is-loading');
        Nebulix.toast((err && err.message) || 'No se pudo agregar al carrito.', 'error');
      });
      return;
    }

    var addBtn = t.closest('[data-add-to-cart]');
    if (addBtn) {
      if (addBtn.disabled || addBtn.getAttribute('data-neb-busy') === '1') return;
      var qty = resolveQty(addBtn);
      var original = addBtn.getAttribute('data-default-text') || addBtn.textContent;
      var addedText = addBtn.getAttribute('data-added-text') || '¡Agregado!';
      var buyRoot = addBtn.closest('[data-neb-buybox]') || doc.querySelector('[data-neb-buybox]');
      var meta = getProductMeta(buyRoot);
      var handle = meta.handle || handleFromLocation();
      var form = buyRoot && buyRoot.querySelector('form[action*="/cart/add"], [data-neb-product-form]');
      var hinted =
        toVariantId(addBtn.getAttribute('data-variant')) ||
        toVariantId(buyRoot && buyRoot.getAttribute('data-variant-id')) ||
        toVariantId(meta.variantId) ||
        '';
      var hidden = form && form.querySelector('[data-selected-variant]');
      if (hidden && toVariantId(hidden.value)) hinted = toVariantId(hidden.value);

      addBtn.disabled = true;
      addBtn.setAttribute('data-neb-busy', '1');
      Nebulix.addItems([{ id: hinted, quantity: qty, handle: handle }], { handle: handle })
        .then(function () {
          addBtn.disabled = false;
          addBtn.removeAttribute('data-neb-busy');
          addBtn.textContent = addedText;
          setTimeout(function () { addBtn.textContent = original; }, 1500);
        })
        .catch(function (err) {
          addBtn.disabled = false;
          addBtn.removeAttribute('data-neb-busy');
          addBtn.textContent = original;
          Nebulix.toast((err && err.message) || 'No se pudo agregar al carrito.', 'error');
        });
      return;
    }

    var bundleAdd = t.closest('[data-bundle-add]');
    if (bundleAdd) {
      var card = bundleAdd.closest('[data-bundle-card]');
      if (!card) return;
      var selects = card.querySelectorAll('[data-bundle-select]');
      var items = [];
      var ok = true;
      selects.forEach(function (s) {
        if (!s.value) { ok = false; return; }
        items.push({ id: s.value, quantity: 1 });
      });
      if (!ok || !items.length) {
        Nebulix.toast('Selecciona todos los productos del pack.', 'error');
        return;
      }
      bundleAdd.disabled = true;
      Nebulix.addItems(items).then(function () { bundleAdd.disabled = false; })
        .catch(function (err) {
          bundleAdd.disabled = false;
          Nebulix.toast((err && err.message) || 'No se pudo agregar el pack.', 'error');
        });
      return;
    }

    var qtyBtn = t.closest('[data-qty-change]');
    if (qtyBtn) {
      var box = qtyBtn.closest('[data-qty-box]');
      var input = box && box.querySelector('[data-qty]');
      if (input) {
        var nv = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
        input.value = nv;
      }
      return;
    }
  };
  document.addEventListener('click', window.__nebPDPOnClick);

  window.__nebPDPOnChange = function (e) {
    var cardVariant = e.target.closest('[data-card-variant-select]');
    if (cardVariant) {
      var cardEl = cardVariant.closest('[data-card-product], .neb-product-card');
      var add = cardEl && cardEl.querySelector('[data-card-add]');
      if (add) add.setAttribute('data-variant', cardVariant.value);
      var opt = cardVariant.options[cardVariant.selectedIndex];
      var priceBox = cardEl && cardEl.querySelector('[data-card-price]');
      var compareBox = cardEl && cardEl.querySelector('[data-card-compare]');
      if (priceBox && opt && opt.getAttribute('data-price')) {
        priceBox.textContent = fmtCOP(opt.getAttribute('data-price'));
      }
      if (compareBox) {
        var cp = opt && opt.getAttribute('data-compare');
        if (cp && parseInt(cp, 10) > parseInt(opt.getAttribute('data-price') || '0', 10)) {
          compareBox.textContent = fmtCOP(cp);
          compareBox.classList.remove('neb-hidden');
        } else {
          compareBox.textContent = '';
        }
      }
    }

    var sel = e.target.closest('[data-bundle-select]');
    if (sel) updateBundle(sel.closest('[data-bundle-card]'));

    var vsel = e.target.closest('[data-variant-select]');
    if (vsel) {
      var form = vsel.closest('form');
      var hidden = form && form.querySelector('[data-selected-variant]');
      if (hidden) hidden.value = vsel.value;
      doc.querySelectorAll('[data-sticky-cta] [data-add-to-cart]').forEach(function (b) { b.setAttribute('data-variant', vsel.value); });
      var optMain = vsel.options[vsel.selectedIndex];
      var priceEl = optMain && doc.querySelector(vsel.getAttribute('data-price-target'));
      var compareEl = optMain && doc.querySelector(vsel.getAttribute('data-compare-target'));
      if (priceEl) priceEl.textContent = fmtCOP(optMain.getAttribute('data-price'));
      if (compareEl) {
        var cp2 = parseInt(optMain.getAttribute('data-compare'), 10);
        var pr = parseInt(optMain.getAttribute('data-price'), 10);
        compareEl.textContent = cp2 > pr ? fmtCOP(cp2) : '';
      }
    }
  };
  document.addEventListener('change', window.__nebPDPOnChange);

  function colorFrom(name) {
    var n = (name || '').toLowerCase();
    var map = {
      'negro': '#111111', 'black': '#111111',
      'blanco': '#ffffff', 'white': '#ffffff', 'gris': '#9ca3af', 'gray': '#9ca3af',
      'azul': '#2563eb', 'blue': '#2563eb', 'rojo': '#dc2626', 'red': '#dc2626',
      'verde': '#16a34a', 'green': '#16a34a', 'rosado': '#ec4899', 'pink': '#ec4899',
      'morado': '#7c3aed', 'purple': '#7c3aed', 'naranja': '#f97316', 'orange': '#f97316',
      'amarillo': '#eab308', 'yellow': '#eab308', 'cafe': '#92400e', 'brown': '#92400e'
    };
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(name)) return name;
    return map[n] || '#d1d5db';
  }

  doc.querySelectorAll('.neb-swatch').forEach(function (s) {
    s.style.background = colorFrom(s.getAttribute('data-color'));
  });

  window.__nebPDPOnSubmit = function (e) {
    var productForm = e.target.closest('[data-product-form]');
    if (productForm) {
      e.preventDefault();
      var cta = productForm.querySelector('[data-add-to-cart][data-main-cta]') ||
        productForm.querySelector('[data-add-to-cart]') ||
        doc.querySelector('[data-sticky-cta] [data-add-to-cart]');
      if (cta) cta.click();
      return;
    }

    var form = e.target.closest('[data-newsletter-form]');
    if (!form) return;
    var input = form.querySelector('input[type="email"]');
    var consent = form.querySelector('[data-newsletter-consent]');
    var email = input ? input.value.trim() : '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      e.preventDefault();
      Nebulix.announce('Ingresa un correo electrónico válido.', 'error');
      return;
    }
    if (consent && !consent.checked) {
      e.preventDefault();
      Nebulix.announce('Debes aceptar la política de tratamiento de datos.', 'error');
      return;
    }
    if (window.NebulixPDPNewsletterHook) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      window.NebulixPDPNewsletterHook(email).then(function () {
        Nebulix.announce('¡Gracias por inscribirte! Revisa tu correo.', 'ok');
        form.reset();
        if (btn) btn.disabled = false;
      }).catch(function () {
        Nebulix.announce('Ocurrió un error. Intenta de nuevo.', 'error');
        if (btn) btn.disabled = false;
      });
      return;
    }
    // Sin hook: deja enviar el form nativo de Shopify (customer / newsletter).
  };
  document.addEventListener('submit', window.__nebPDPOnSubmit);

  function updateBundle(card) {
    if (!card) return;
    var selects = card.querySelectorAll('[data-bundle-select]');
    var current = card.querySelector('[data-bundle-current]');
    var compare = card.querySelector('[data-bundle-compare]');
    var btn = card.querySelector('[data-bundle-add]');
    var help = card.querySelector('[data-bundle-help]');
    var discount = parseFloat(card.getAttribute('data-bundle-discount') || '0');
    var total = 0;
    var full = 0;
    var ok = true;
    selects.forEach(function (s) {
      if (!s.value) { ok = false; return; }
      total += parseInt(s.getAttribute('data-price') || '0', 10);
      full += parseInt(s.getAttribute('data-compare') || s.getAttribute('data-price') || '0', 10);
    });
    btn.disabled = !ok;
    if (help) help.classList.toggle('neb-hidden', ok);
    var target = ok && discount > 0 ? Math.round(total * (1 - discount / 100)) : total;
    if (current) current.textContent = fmtCOP(target);
    if (compare) {
      compare.style.display = ok && full > total ? '' : 'none';
      compare.textContent = fmtCOP(full);
    }
  }

  document.querySelectorAll('[data-bundle-card]').forEach(updateBundle);

  var sticky = doc.querySelector('[data-sticky-cta]');
  var mainCta = doc.querySelector('[data-main-cta]');
  if (sticky && mainCta && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting); });
    }, { rootMargin: '0px 0px -120px 0px' });
    io.observe(mainCta);
  }

  function initHeader() {
    var header = doc.querySelector('[data-site-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  initHeader();

  function initAccordions() {
    doc.querySelectorAll('.neb-acc-item.is-open > .neb-acc-panel').forEach(function (p) {
      p.style.maxHeight = p.scrollHeight + 'px';
    });
    doc.querySelectorAll('.neb-tabs__panel.is-open > .neb-panel-body').forEach(function (p) {
      p.style.maxHeight = p.scrollHeight + 'px';
    });
  }
  initAccordions();

  function initReviewClamp() {
    doc.querySelectorAll('[data-review-clamp]').forEach(function (p) {
      var max = parseInt(p.getAttribute('data-review-clamp'), 10);
      var full = p.textContent.trim();
      if (full.length <= max) return;
      var short = full.slice(0, max) + '…';
      p.textContent = short;
      p.setAttribute('data-fulltext', full);
      var btn = doc.createElement('button');
      btn.type = 'button';
      btn.textContent = 'Leer más';
      btn.className = 'neb-review__more';
      btn.addEventListener('click', function () {
        p.textContent = p.getAttribute('data-fulltext');
        btn.remove();
      });
      p.insertAdjacentElement('afterend', btn);
    });
  }
  initReviewClamp();

  /* ---- Generic transform slider: responsive cards, autoplay, dots, arrows ---- */
  function initSlider(track, cfg) {
    if (!track) return;
    var items = [].slice.call(track.children);
    var total = items.length;
    if (total < 2) return;

    var idx = 0;
    var maxIdx = total - 1;
    var timer = null;

    function gapOf() {
      var g = parseFloat(win.getComputedStyle(track).columnGap) || parseFloat(win.getComputedStyle(track).gap) || 0;
      return g > 0 ? g : 0;
    }
    function measureWidth() {
      var parent = track.parentElement;
      if (parent) {
        var pw = parent.clientWidth;
        if (pw > 0) return pw;
      }
      return track.clientWidth;
    }
    function perView() {
      var w = measureWidth();
      var pv = cfg.perView;
      if (typeof pv === 'function') return Math.max(1, pv(w));
      return Math.max(1, pv || 1);
    }
    function buildDots() {
      var wrap = cfg.dots && doc.querySelector(cfg.dots);
      if (wrap) {
        var n = maxIdx + 1;
        if (wrap.childElementCount !== n) {
          wrap.innerHTML = '';
          for (var i = 0; i < n; i++) {
            (function (i) {
              var d = doc.createElement('button');
              d.type = 'button';
              d.setAttribute('aria-label', 'Ir a la posición ' + (i + 1));
              d.setAttribute('data-i', i);
              d.addEventListener('click', function () { goTo(i); if (cfg.autoplay) startTimer(); });
              wrap.appendChild(d);
            })(i);
          }
        }
        [].forEach.call(wrap.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
      if (cfg.progress) {
        var bar = doc.querySelector(cfg.progress);
        if (bar) {
          var pct = maxIdx <= 0 ? 100 : ((idx + 1) / (maxIdx + 1)) * 100;
          bar.style.width = pct + '%';
        }
      }
    }
    function goTo(i, instant) {
      idx = Math.max(0, Math.min(i, maxIdx));
      var x = idx * (items[0].getBoundingClientRect().width + gapOf());
      if (instant) track.style.transition = 'none';
      track.style.transform = 'translateX(-' + x + 'px)';
      if (instant) requestAnimationFrame(function () { track.style.transition = ''; });
      buildDots();
    }
    function applyLayout() {
      var pv = perView();
      var peek = (pv === 1 && cfg.peek) ? cfg.peek : 0;
      var baseW = measureWidth();
      if (!(baseW > 0)) return;
      var bw = Math.floor((baseW - (pv - 1) * gapOf() - peek) / pv);
      if (!(bw > 0)) return;
      items.forEach(function (it) {
        it.style.flex = '0 0 ' + bw + 'px';
        it.style.width = bw + 'px';
        it.style.maxWidth = 'none';
        it.style.boxSizing = 'border-box';
        it.style.height = 'auto';
      });
      maxIdx = Math.max(0, total - pv);
      if (idx > maxIdx) idx = maxIdx;
      if (cfg.equalHeight && win.innerWidth >= 720) {
        var maxH = 0;
        items.forEach(function (it) { maxH = Math.max(maxH, it.offsetHeight); });
        items.forEach(function (it) { it.style.height = maxH + 'px'; });
      } else {
        items.forEach(function (it) { it.style.height = 'auto'; });
      }
      goTo(idx, true);
      buildDots();
    }
    function next() { goTo(idx >= maxIdx ? 0 : idx + 1); }
    function prev() { goTo(idx <= 0 ? maxIdx : idx - 1); }
    function startTimer() {
      if (!cfg.autoplay) return;
      clearInterval(timer);
      timer = setInterval(next, cfg.autoplay);
    }
    function stopTimer() { clearInterval(timer); timer = null; }

    var prevBtn = cfg.prev && doc.querySelector(cfg.prev);
    var nextBtn = cfg.next && doc.querySelector(cfg.next);
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startTimer(); });

    if (cfg.pauseOnHover !== false) {
      track.addEventListener('mouseenter', stopTimer);
      track.addEventListener('mouseleave', startTimer);
    }
    doc.addEventListener('visibilitychange', function () { doc.hidden ? stopTimer() : startTimer(); });

    var sx = 0;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var d = sx - e.changedTouches[0].clientX;
      if (Math.abs(d) > 40) { d > 0 ? next() : prev(); startTimer(); }
    }, { passive: true });

    var rt;
    win.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { applyLayout(); }, 150);
    });

    applyLayout();
    startTimer();
  }

  initSlider(doc.querySelector('[data-reviews-track]') || doc.querySelector('.neb-reviews__list'), {
    prev: '[data-reviews-viewport] [data-rev-prev], .neb-reviews__nav [data-rev-prev]',
    next: '[data-reviews-viewport] [data-rev-next], .neb-reviews__nav [data-rev-next]',
    progress: '[data-rev-progress]',
    autoplay: 4500,
    peek: 0,
    equalHeight: true,
    pauseOnHover: false,
    perView: function (w) { return w >= 1024 ? 3 : (w >= 720 ? 2 : 1); }
  });

  var crossTrack = doc.querySelector('[data-cross-track]');
  if (crossTrack && crossTrack.querySelector('.neb-cross__item, .neb-product-card')) {
    initSlider(crossTrack, {
      prev: '[data-cross-prev]',
      next: '[data-cross-next]',
      equalHeight: false,
      pauseOnHover: true,
      perView: function (w) {
        if (w >= 1024) return 4;
        if (w >= 768) return 3;
        if (w >= 480) return 2;
        return 1;
      },
      peek: 56
    });
  }

  var bundleTrack = doc.querySelector('[data-bundle-track]');
  if (bundleTrack && bundleTrack.querySelector('.neb-bundle__item, .neb-product-card')) {
    initSlider(bundleTrack, {
      prev: '[data-bundle-prev]',
      next: '[data-bundle-next]',
      autoplay: parseInt(bundleTrack.getAttribute('data-autoplay') || '4000', 10),
      equalHeight: false,
      perView: function (w) { return w >= 1000 ? 4 : (w >= 720 ? 3 : (w >= 480 ? 2 : 1)); }
    });
  }

  Nebulix.cartDrawerEl = doc.querySelector('[data-cart-drawer]');
  paintAllShippingBars({ total_price: 0, item_count: 0 });

  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      Nebulix.setCount(cart.item_count);
      paintAllShippingBars(cart);
    })
    .catch(function () { Nebulix.setCount(0); });

  doc.addEventListener('nebulix:cart:open', function () { Nebulix.openDrawer(); });
  doc.addEventListener('nebulix:cart:add', function (e) { if (e.detail) Nebulix.addItems(e.detail); });

  hydrateBuyboxVariantFromStorefront();

  /* Escape key closes cart drawer and mobile menu */
  window.__nebPDPOnKeydown = function (e) {
    if (e.key !== 'Escape') return;
    var cart = doc.querySelector('[data-cart-drawer]');
    if (cart && cart.classList.contains('is-open')) { Nebulix.closeDrawer(); return; }
    var menu = doc.querySelector('[data-mobile-menu]');
    if (menu && (menu.classList.contains('is-open') || menu.getAttribute('aria-hidden') === 'false')) {
      Nebulix.setMobileMenuOpen(false);
    }
  };
  doc.addEventListener('keydown', window.__nebPDPOnKeydown);
})();
